module.exports = __webpack_public_path__ + "img/WechatIMG76.c59befd4.jpg";